import { useState } from 'react'
import { createPortal } from 'react-dom'
import { toast } from 'react-toastify'

import { Dialog } from '@loadsmart/miranda-react'

import { formatAssignTruckDialogTitle } from '../../../presenters/trackingPresenter'
import { TruckForm } from './TruckForm'
import { TruckSelection } from './TruckSelection'

type AssignTruckNumberDialogProps = {
  readonly open: boolean
  readonly carrierUUID: string
  readonly tractorNumber?: string
  readonly shipmentUUID: string
  readonly onClose: () => void
  readonly onTruckAssigned: () => void
}

export function AssignTruckNumberDialog({
  open,
  shipmentUUID,
  carrierUUID,
  tractorNumber,
  onClose,
  onTruckAssigned,
}: AssignTruckNumberDialogProps) {
  const [addingTruck, setAddingTruck] = useState(false)

  function handleSuccess() {
    toast.success('Truck assigned successfully')
    onTruckAssigned()
    onClose()
  }

  return createPortal(
    <Dialog open={open} data-testid="assign-truck-dialog" onClose={onClose}>
      <Dialog.Header>
        {formatAssignTruckDialogTitle(tractorNumber)}
        <Dialog.Close data-testid="assign-truck-dialog-close" onClick={onClose} />
      </Dialog.Header>
      {addingTruck ? (
        <TruckForm
          carrierUUID={carrierUUID}
          shipmentUUID={shipmentUUID}
          onCancel={() => setAddingTruck(false)}
          onSave={handleSuccess}
        />
      ) : (
        <TruckSelection
          carrierUUID={carrierUUID}
          tractorNumber={tractorNumber}
          shipmentUUID={shipmentUUID}
          onAddNewTruck={() => setAddingTruck(true)}
          onCancel={onClose}
          onTruckAssigned={handleSuccess}
        />
      )}
    </Dialog>,
    document.body,
    'assign-truck-dialog-root'
  )
}
